import { ListenerEffect } from '@reduxjs/toolkit'
import { SearchMetric } from 'legacy/lut/configs/metrics'
import { TAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { selectCountries } from 'legacy/lut/selectors/app'
import { IState } from 'legacy/lut/store'
import type { AnyAction } from 'redux'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { search } from 'clickNgo/services/search_v2'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { measureRequest } from 'shared/lib/metrics'

import { searchPartner } from '../../../services/search'
import { mapQueryParamsToRequestData } from '../../../services/search/mapping'
import { updatePartnerSearchRequestInfo, updateSearchResults } from '../partnerSearchSlice'
import { selectPartnerSearchFilters } from '../selectors'

export const fetchPartnersAndContactsEffect: ListenerEffect<
  AnyAction,
  IState,
  TAppDispatch
> = async (_, { getState, dispatch }) => {
  const state = getState()
  dispatch(updatePartnerSearchRequestInfo({ status: RequestStatus.PENDING, message: '' }))

  const isElasticSearch = state.partnerSearch.isElasticSearch
  const countries = selectCountries(state)
  const user = selectUser(state)
  const filters = selectPartnerSearchFilters(state)

  const requestData = mapQueryParamsToRequestData(filters)

  if (isElasticSearch) {
    const [partnersResponse, contactsResponse] = await Promise.all([
      measureRequest(SearchMetric.Partners, user, () =>
        search({ filters, user, countries }, 'partners')
      ),
      measureRequest(SearchMetric.Contacts, user, () =>
        search({ filters, user, countries }, 'contacts')
      ),
    ])

    const partners = partnersResponse.data.items ?? []
    const contacts = contactsResponse.data.items ?? []
    dispatch(updateSearchResults({ partners, contacts }))
  } else {
    await measureRequest(SearchMetric.PartnersAndContacts, user, () =>
      searchPartner({ requestData, user })
    )
  }

  dispatch(updatePartnerSearchRequestInfo({ status: RequestStatus.FULFILLED, message: '' }))
}
